module.exports = flarum.core.compat['forum/ForumApplication'];